export const MENU_ITEM_TEST_ID = 'menu-item';

export const GRID_AREA_TITLE = 'title';
export const GRID_AREA_SUBTITLE = 'subtitle';
